import React, { memo, useMemo, useState } from "react";
import { Modal, Input } from "antd";
import { useSelector } from "react-redux";
import { selectProjectList } from "../../../store/slices/projects";
import { CheckOutlined } from "@ant-design/icons";
import "./add-project-modal.css";

export const AddProjectModal = memo(({ open, onClose, selectedProjectIds = [], onSelect }) => {
  const allProjects = useSelector(selectProjectList) || [];
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    if (!search.trim()) return allProjects;
    return allProjects.filter(p =>
      p.title.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, allProjects]);

  const handleSelect = (p) => {
    if (selectedProjectIds.includes(p.id)) return;
    onSelect?.(p);
    onClose?.();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={260}
      closable={false}
      className="ap-modal"
      destroyOnHidden
      mask={true}
    >
      <div className="ap-header">Select project</div>

      <div className="ap-search">
        <Input
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          allowClear
        />
      </div>

      <div className="ap-divider" />

      <div className="ap-list">
        {filtered.map((p) => {
          const isSelected = selectedProjectIds.includes(p.id);
          return (
            <button
              key={p.id}
              className={`ap-row ${isSelected ? "ap-row--disabled" : ""}`}
              onClick={() => handleSelect(p)}
              type="button"
              title={p.title}
              disabled={isSelected}
            >
              <div className="ap-row__title">{p.title}</div>
              {isSelected && <CheckOutlined className="ap-row__check" />}
            </button>
          );
        })}
      </div>
    </Modal>
  );
});